import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, BadgeCheck } from "lucide-react";

export default function FreeNoticePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("koss_free_notice_seen")) return;
    const t = setTimeout(() => setOpen(true), 900);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    sessionStorage.setItem("koss_free_notice_seen", "1");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="popup-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={close}
          data-testid="free-notice-popup"
        >
          <motion.div
            className="popup-card"
            initial={{ opacity: 0, scale: 0.9, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.94, y: 12 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="popup-close" onClick={close} aria-label="Close" data-testid="free-notice-close">
              <X size={18} />
            </button>
            <div className="popup-icon">
              <BadgeCheck size={26} strokeWidth={2} />
            </div>
            <h3>Registration and attendance is free</h3>
            <p>
              Every selected delegate attends KOSS 2027 at no cost — sessions,
              materials, working lunch and the professional headshot included.
            </p>
            <button className="btn popup-btn" onClick={close} data-testid="free-notice-ok">
              Got it →
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
